{
  "aiGeneratedAnswer": "Tekoälyn luoma vastaus",
  "allCategories": "Kaikki kategoriat",
  "appliedFiltersToCurrentSearch": "Käytetyt suodattimet nykyiseen hakuun",
  "apply": "Käytä",
  "applyFilters": "Käytä suodattimia",
  "autocompleteOptionsFound_one": "{{count}}{{label}} automaattista ehdotusta löytyi.",
  "autocompleteOptionsFound_other": "{{count}}{{label}} automaattista ehdotusta löytyi.",
  "autocompleteSuggestion": "automaattinen ehdotus: {{suggestion}}",
  "autocompleteSuggestionsFound_one": "{{count}} automaattinen ehdotus löytyi.",
  "autocompleteSuggestionsFound_other": "{{count}} automaattista ehdotusta löytyi.",
  "basedOnYourDevice": " (perustuu laitteeseesi)",
  "basedOnYourInternetAddress": " (perustuu internet-osoitteeseesi)",
  "categoriesText_one": "Seuraava kategoria antoi tuloksia hakusanalle - <strong>{{query}}</strong>",
  "categoriesText_other": "Seuraavat kategoriat antoivat tuloksia hakusanalle - <strong>{{query}}</strong>",
  "clearAll": "Tyhjennä kaikki",
  "clearMinAndMax": "Tyhjennä minimi ja maksimi",
  "clearTheRangeToSelectOptions": "Tyhjennä valintaväli.",
  "clearTheSearchBar": "Tyhjennä hakupalkki",
  "conductASearch": "Tee haku",
  "currentLocation": "Nykyinen sijainti",
  "didYouMean": "Tarkoititko <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Kun automaattiset tulokset ovat saatavilla, käytä nuolinäppäimiä selaamiseen ja Enteriä valitsemiseen.",
  "feedback": "Palaute",
  "filterGroupSearchInputLabel": "Hae {{title}}-vaihtoehdoista",
  "invalidRange": "Virheellinen väli",
  "max": "Maks",
  "min": "Min",
  "navigateToTheNextResultsPage": "Siirry seuraavalle tulossivulle",
  "navigateToThePreviousResultsPage": "Siirry edelliselle tulossivulle",
  "noAutocompleteOptionsFound": "0 automaattista ehdotusta löytyi.",
  "noAutocompleteSuggestionsFound": "0 automaattista ehdotusta löytyi.",
  "noResultsFoundIn": "Tuloksia ei löytynyt kohdasta {{currentVerticalLabel}}.",
  "paginationPage": "sivu {{pageNumber}}",
  "pagination": "Sivutus",
  "readMoreAbout": "Lue lisää aiheesta <a>{{name}}</a>",
  "recentSearch": "viimeisin haku: {{query}}",
  "recentSearchesFound_one": "{{count}} viimeisin haku löytyi.",
  "recentSearchesFound_other": "{{count}} viimeisintä hakua löytyi.",
  "removeFilter": "Poista suodatin \"{{displayName}}\"",
  "resultPreview": "tuloksen esikatselu: {{value}}",
  "resultPreviewsFound_one": "{{count}} tuloksen esikatselu löytyi.",
  "resultPreviewsFound_other": "{{count}} tuloksen esikatselua löytyi.",
  "resultsCountText_one": "{{count}} tulos",
  "resultsCountText_other": "{{count}} tulosta",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} / {{resultsCount}} tulosta",
  "searchHere": "Hae tästä…",
  "showingAllInstead": "Näytetään kaikki kohteessa {{currentVerticalLabel}} sen sijaan.",
  "showLess": "Näytä vähemmän",
  "showMore": "Näytä lisää",
  "sources_one": "Lähde",
  "sources_other": "Lähteet ({{count}})",
  "submitSearch": "Lähetä haku",
  "suggestionResultsCount_one": "{{label}} - {{count}} tulos",
  "suggestionResultsCount_other": "{{label}} - {{count}} tulosta",
  "thankYouForYourFeedback": "Kiitos palautteestasi!",
  "thisAnsweredMyQuestion": "Tämä vastasi kysymykseeni",
  "thisDidNotAnswerMyQuestion": "Tämä ei vastannut kysymykseeni",
  "unselectAnOptionToEnterInARange": "Poista valinta päästäksesi syöttämään välin.",
  "updateYourLocation": "Päivitä sijaintisi",
  "useCurrentLocation": "Käytä nykyistä sijaintia",
  "useMyLocation": "Käytä sijaintiani",
  "viewAll": "Näytä kaikki",
  "viewDetails": "Näytä tiedot"
}
